import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const { login }               = useAuth();
  const navigate                = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Credenciales incorrectas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700;800&family=Barlow:wght@300;400;500&display=swap');
        .login-root {
          min-height: 100vh;
          display: grid;
          grid-template-columns: 1fr 1fr;
          font-family: 'Barlow', sans-serif;
        }
        @media (max-width: 768px) {
          .login-root { grid-template-columns: 1fr; }
          .login-brand { display: none; }
        }
        .login-brand {
          background: #111;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 48px;
          position: relative;
          overflow: hidden;
        }
        .login-brand::before {
          content: '2CAP';
          position: absolute;
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 280px;
          font-weight: 800;
          color: rgba(255,255,255,0.04);
          bottom: -40px;
          left: -20px;
          line-height: 1;
          letter-spacing: -8px;
          pointer-events: none;
        }
        .brand-logo-mark {
          display: inline-flex;
          align-items: center;
          gap: 12px;
        }
        .brand-square {
          width: 36px;
          height: 36px;
          background: #dc1414;
        }
        .brand-name {
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 22px;
          font-weight: 700;
          color: #fff;
          letter-spacing: 2px;
          text-transform: uppercase;
        }
        .brand-tagline {
          font-size: 13px;
          color: rgba(255,255,255,0.35);
          letter-spacing: 3px;
          text-transform: uppercase;
          font-weight: 300;
        }
        .brand-headline {
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 52px;
          font-weight: 800;
          color: #fff;
          line-height: 1.05;
          letter-spacing: -1px;
          text-transform: uppercase;
        }
        .brand-headline span { color: #dc1414; }
        .brand-meta {
          font-size: 12px;
          color: rgba(255,255,255,0.25);
          letter-spacing: 2px;
          text-transform: uppercase;
        }
        .login-form-side {
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 48px;
        }
        .login-form-inner {
          width: 100%;
          max-width: 380px;
        }
        .form-eyebrow {
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 3px;
          text-transform: uppercase;
          color: #dc1414;
          margin-bottom: 12px;
        }
        .form-title {
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 36px;
          font-weight: 700;
          color: #111;
          line-height: 1.1;
          margin-bottom: 8px;
          text-transform: uppercase;
          letter-spacing: -0.5px;
        }
        .form-subtitle {
          font-size: 14px;
          color: #888;
          margin-bottom: 36px;
          font-weight: 300;
        }
        .form-error {
          background: #fff0f0;
          border-left: 3px solid #dc1414;
          color: #b91c1c;
          padding: 12px 16px;
          font-size: 13px;
          margin-bottom: 20px;
          font-weight: 500;
        }
        .form-label {
          display: block;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: #555;
          margin-bottom: 8px;
        }
        .form-field { margin-bottom: 20px; }
        .form-input {
          width: 100%;
          padding: 13px 16px;
          border: 1.5px solid #e5e5e5;
          border-radius: 0;
          font-size: 15px;
          font-family: 'Barlow', sans-serif;
          font-weight: 400;
          color: #111;
          outline: none;
          transition: border-color 0.2s;
          box-sizing: border-box;
          background: #fafafa;
        }
        .form-input:focus { border-color: #111; background: #fff; }
        .form-submit {
          width: 100%;
          padding: 15px;
          background: #111;
          color: #fff;
          border: none;
          font-family: 'Barlow Condensed', sans-serif;
          font-size: 16px;
          font-weight: 700;
          letter-spacing: 3px;
          text-transform: uppercase;
          cursor: pointer;
          transition: background 0.2s;
          margin-top: 8px;
        }
        .form-submit:hover:not(:disabled) { background: #dc1414; }
        .form-submit:disabled { opacity: 0.5; cursor: not-allowed; }
        .form-footer {
          margin-top: 24px;
          padding-top: 24px;
          border-top: 1px solid #f0f0f0;
          font-size: 12px;
          color: #aaa;
          text-align: center;
          letter-spacing: 1px;
        }
      `}</style>
      <div className="login-root">
        <div className="login-brand">
          <div className="brand-logo-mark">
            <div className="brand-square" />
            <span className="brand-name">2CAP</span>
          </div>
          <div>
            <div className="brand-headline">
              Programa<br />de <span>Lealtad</span><br />2CAP
            </div>
          </div>
          <div>
            <div className="brand-tagline">Panel de administración</div>
            <div className="brand-meta" style={{ marginTop: 8 }}>© 2026 Operadora de Tiendas Garcam</div>
          </div>
        </div>

        <div className="login-form-side">
          <div className="login-form-inner">
            <div className="form-eyebrow">Acceso restringido</div>
            <div className="form-title">Iniciar<br />sesión</div>
            <div className="form-subtitle">Ingresa tus credenciales para continuar</div>

            {error && <div className="form-error">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="form-field">
                <label className="form-label">Correo electrónico</label>
                <input className="form-input" type="email" value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="tu@2cap.com.mx" required />
              </div>
              <div className="form-field">
                <label className="form-label">Contraseña</label>
                <input className="form-input" type="password" value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••" required />
              </div>
              <button className="form-submit" type="submit" disabled={loading}>
                {loading ? 'Verificando...' : 'Ingresar'}
              </button>
            </form>

            <div className="form-footer">Acceso autorizado únicamente</div>
          </div>
        </div>
      </div>
    </>
  );
}
